import s from './Disclaimer.module.scss';

export default function Disclaimer({ heading, children }) {
  return (
    <div className={s.wrapper}>
      {heading && <div className={s.heading}>{heading}</div>}
      <div className={s.body}>{children}</div>
    </div>
  );
}
